import { useMutation } from "@tanstack/react-query";
import { projectsApi } from "@/api/projects.ts";

/**
 * Opens the project's VS Code (code-server) in a new tab. The tab is opened synchronously on click
 * (popup blockers) and pointed at the signed entry link once code-server is up.
 */
export function useOpenIde(projectId: string) {
  return useMutation({
    mutationFn: async () => {
      const w = window.open("about:blank", `codvero-ide-${projectId}`);
      try {
        const e = await projectsApi.ideOpen(projectId);
        if (w) w.location.href = e.url;
        else window.open(e.url, "_blank");
        return e;
      } catch (err) {
        w?.close();
        throw err;
      }
    },
  });
}
